/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from '../types/index';

function IllustStatusErrorCommon({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 200 200"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fill="#B6BAC1"
        d="M99.776 39.75c17.876 0 32.768 12.965 35.812 29.98 14.325 1.902 25.433 13.587 25.433 29.127 0 15.894-12.658 28.865-28.421 29.372l-.04.001-64.663.02c-16.2 0-29.376-13.185-29.376-29.393 0-14.876 11.1-27.194 25.44-29.126 3.036-17.016 17.94-29.981 35.815-29.981m0 2.5c-16.946 0-31.036 12.521-33.498 28.798a1.25 1.25 0 0 1-1.11 1.056C51.632 73.479 41.023 84.95 41.022 98.858c0 14.829 12.058 26.892 26.874 26.892l64.645-.019c14.409-.474 25.981-12.34 25.981-26.873 0-14.55-10.582-25.377-24.137-26.752a1.25 1.25 0 0 1-1.11-1.056c-2.472-16.28-16.552-28.8-33.499-28.8"
      />
      <path
        fill="#FAE100"
        d="m105.382 118.91 14.07-20.92c1.41-2.09-.26-4.76-2.96-4.76h-25.88c-2.25 0-4.17 1.47-4.55 3.48l-6.44 34.07c-.36 1.91 1.27 3.66 3.42 3.66h6.58c.89 0 1.57.73 1.42 1.52l-4.66 25.17c-.42 2.26 2.92 3.38 4.23 1.43l24.97-37.12c1.41-2.09-.26-4.76-2.96-4.76h-6.14c-1 0-1.61-.99-1.09-1.76z"
      />
    </svg>
  );
}
export default IllustStatusErrorCommon;
